import { DatePickerTextField } from '@abbott-components/core';
import { JSONSchema7 } from 'json-schema';
import ControlState from '../../Shared/controlState';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import { useContext } from 'react';
import { WorkflowEngineContext } from '../../WorkflowEngine/workflowEngineReducer';

export default (control: ControlState) => {
  const { state } = useContext(WorkflowEngineContext);

  const { isReadOnlyView } = state;

  const properties = control.schema?.properties as JSONSchema7Properties;

  const labelSchema = properties['label'] as JSONSchema7;

  const minDate = new Date(properties['minimumDate'].default as string);

  const maxDate = new Date(properties['maximumDate'].default as string);

  return (
    <DatePickerTextField
      PopperProps={{
        placement: 'bottom-end'
      }}
      label={labelSchema?.default as string}
      name={control.id}
      minDate={minDate}
      maxDate={maxDate}
      defaultValue={null}
      disabled={isReadOnlyView}
    />
  );
};
